export class IProviderDetails {
  internalId: string;
  name: string;
  office: string;
  userSite: string;
  taxId: string;
  npiId: string;
  searchableTypes: string;
  IPA: IPAList[];
  providerNotFound: boolean;
}

export class IPAList {
  neighbourhood: string;
  group: string;
  speciality: string;
  address: string;
  phone: string;
  status: string;
  city: string;
  subSpeciality: string;
}

export class IProviderContract {
  neighbourhood: string;
  region: string;
  speciality: string;
  address: string;
  phone: string;
  status: string;
  group: string;
}

export class IProviderSiteSearch {
  page: string;
  size: string;
  siteTypeUid: string;
  description: string;
  providerUid: Number;
  providerContractUid: string;
}
